import React from 'react'
import { useTranslation } from 'react-i18next'

import Box, { BoxProps } from '@/modules/components/Box'
import Link from '@/modules/components/Link'
import { Popover } from '@/modules/components/Popover'

import { CompanySec, LearnSec, Section } from '../data'
import { useToggleMenu } from '../useToggleMenu'
import { CompanyMenu } from './CompanyMenu/index'
import DesktopMenuItem from './DesktopMenuItem'
import { LearnMenu } from './LearnMenu'
import { ProductMenu } from './ProductMenu'

type DesktopMenuProps = {
  variant: 'dark' | 'light'
  products: Section[]
  company: CompanySec[]
  isShowNFT: boolean
  isShowPrice: boolean
  learnSec?: LearnSec[]
} & BoxProps

export const DesktopMenu = ({
  variant,
  products,
  company,
  isShowNFT,
  isShowPrice,
  learnSec,
  ...restProps
}: DesktopMenuProps) => {
  const { t } = useTranslation('navigation')
  const [isProductOpen, toggleProduct] = useToggleMenu()
  const [isCompanyOpen, toggleCompany] = useToggleMenu()
  const [isLearnOpen, toggleLearn] = useToggleMenu()

  return (
    <Box {...restProps}>
      {isShowNFT && (
        <Box>
          <Link href="https://crypto.com/nft">
            <DesktopMenuItem
              chevron={null}
              variant={variant}
              title={t('navbar.nft')}
            />
          </Link>
        </Box>
      )}
      {isShowPrice && (
        <Link href="https://crypto.com/price">
          <DesktopMenuItem
            variant={variant}
            title={t('navbar.price')}
            chevron={null}
            marginLeft={3}
          />
        </Link>
      )}
      <Popover
        variant="container"
        isOpen={isProductOpen}
        onOutsideClick={toggleProduct}
        onMouseEnter={toggleProduct}
        onMouseLeave={toggleProduct}
        marginLeft={3}
        content={
          <ProductMenu products={products} onClickMenuLink={toggleProduct} />
        }
        align="center"
        // Visual adjustment to align arrow to chevron
        offset={-4}
      >
        <DesktopMenuItem
          variant={variant}
          title={t('navbar.product')}
          onClick={toggleProduct}
        />
      </Popover>
      <Popover
        isOpen={isCompanyOpen}
        onOutsideClick={toggleCompany}
        onMouseEnter={toggleCompany}
        onMouseLeave={toggleCompany}
        marginLeft={3}
        content={
          <CompanyMenu company={company} onClickMenuLink={toggleCompany} />
        }
        align="center"
        // Visual adjustment to align arrow to chevron
        offset={-4}
      >
        <DesktopMenuItem
          variant={variant}
          title={t('navbar.company')}
          onClick={toggleCompany}
        />
      </Popover>
      {learnSec && (
        <Popover
          isOpen={isLearnOpen}
          onOutsideClick={toggleLearn}
          onMouseEnter={toggleLearn}
          onMouseLeave={toggleLearn}
          marginLeft={3}
          content={
            <LearnMenu learnSec={learnSec} onClickMenuLink={toggleLearn} />
          }
          align="center"
          // Visual adjustment to align arrow to chevron
          offset={-4}
        >
          <DesktopMenuItem
            variant={variant}
            title={t('navbar.learn')}
            onClick={toggleLearn}
          />
        </Popover>
      )}
    </Box>
  )
}
